module.exports = color => {
  return color === 'red' ? 'white' : 'black'
}
